export default [
    //app
    {
        path: '/app/login/login',
        name: '/app/login/login',
        component: () =>
            import ('../views/app/login/login.vue'),
    },
]